import "@fontsource/poppins/300.css"; // light
import "@fontsource/poppins/400.css"; // regular
import "@fontsource/poppins/500.css"; // medium
import "@fontsource/poppins/600.css"; // semibold
import "@fontsource/poppins/700.css"; // bold
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import GlobalErrorBoundary from "./components/GlobalErrorHandler";
import { ProviderChakra } from "./components/ui/provider";
import { Toaster } from "./components/ui/toaster";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ProviderChakra>
    <Provider store={store}>
      <GlobalErrorBoundary>
        <Toaster />
        <App />
      </GlobalErrorBoundary>
    </Provider>
  </ProviderChakra>
);
